import React from "react";
import { useTranslation } from "react-i18next";

const DangerAlert = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-[#fbebed] border border-[#f3c6cd] text-[#b9384f] px-4 py-3 rounded-lg flex items-start gap-3 relative">
      <i className="fas fa-exclamation-circle mt-1 text-[16px]" />
      <div className="flex-1 flex flex-col gap-1">
        <p className="text-[14px] font-extrabold leading-[20px]">
          {t("Dangerous waste identified")}
        </p>
        <p className="text-[13px] leading-[18px] text-[#b9384f]">
          {t(
            "Potentially dangerous waste has been identified, please check the waste carefully.",
          )}
        </p>
      </div>

      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 text-[#b9384f] hover:text-[#8d2a3f] transition-colors"
          aria-label={t("Close")}
        >
          <i className="fas fa-times text-[14px]" />
        </button>
      )}
    </div>
  );
};
export default DangerAlert;
